module.exports = "<cco-radiobuttongroup [group]=\"group\" name=\"claimDataSource\" [options]=\"claimSourceOptions\">\r\n</cco-radiobuttongroup>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/claim/claim-list/claim-source-search/claim-source-search.component.html
// module id = ../../../../../src/app/claim/claim-list/claim-source-search/claim-source-search.component.html
// module chunks = main